import React, { useEffect, useState } from 'react';

import CheckboxInput from 'CommonComponents/CheckboxInput';
import Modal from 'CommonComponents/Modal';
import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';

/**
 * Delete All on a plan page that rolls up several plans: one checkbox per plan, all ticked each
 * time it opens. `plans` lists the page's own plan first, and its name heads the message.
 */
const ProjectPlanDeleteAllModal = ({ id, modal, plans, onConfirm }) => {
    const [tickedIds, setTickedIds] = useState(() => new Set());

    useEffect(() => {
        if (modal.visible) {
            setTickedIds(new Set(plans.map((plan) => plan.id)));
        }
    }, [modal.visible, plans]);

    const toggle = (planId) => {
        setTickedIds((previous) => {
            const next = new Set(previous);
            next.has(planId) ? next.delete(planId) : next.add(planId);

            return next;
        });
    };

    const confirm = () => {
        onConfirm(plans.filter((plan) => tickedIds.has(plan.id)).map((plan) => plan.id));
        modal.hide();
    };

    return (
        <Modal id={id} modal={modal}>
            <ModalHeader title={$t('Delete All')} close={modal.hide}></ModalHeader>
            <div className="tw-space-y-4">
                <div className="modal__form-container tw-space-y-4">
                    <div className="modal__msg modal__text-color">
                        {$t('This will delete the plans for {{name}} and its cost centres. Untick any plan you want to keep.', {
                            name: plans[0]?.name,
                        })}
                    </div>
                    <div className="tw-space-y-2">
                        {plans.map((plan) => (
                            <CheckboxInput key={plan.id} label={plan.name} checked={tickedIds.has(plan.id)} onChange={() => toggle(plan.id)} />
                        ))}
                    </div>
                </div>
                <ModalFooter
                    cancelButtonText={$t('Cancel')}
                    primaryButtonText={$t('Delete')}
                    submitButtonVariant="danger"
                    primaryButtonDisabled={!tickedIds.size}
                    onCancel={modal.hide}
                    handleSubmit={confirm}
                />
            </div>
        </Modal>
    );
};

export default ProjectPlanDeleteAllModal;
